import styled from 'styled-components';

const StyledMedicalLeaveFormPayersTable = styled.div`
   margin-top: 20px;
   min-width: 540px;
`;
StyledMedicalLeaveFormPayersTable.displayName = 'StyledMedicalLeaveFormPayersTable';

export { StyledMedicalLeaveFormPayersTable };
